const iconMap = {
  'conversation-started': 'fa-message-lines',
  'conversation-assigned': 'fa-user-plus',
  'conversation-unassigned': 'fa-user-minus',
  'conversation-closed': 'fa-message-check',
  'conversation-rated': 'fa-star',
  'conversation-reopened': 'fa-message-captions',
};

const hasCorrectData = ({ activity, hasAssociated = false }) => {
  const { actor_id, actor, associated_id, associated } = activity;
  return actor_id && actor && (!hasAssociated || (associated_id && associated));
};

const hasAssignedThemselves = (activity) => {
  const { actor, associated } = activity;

  return actor.model === associated.model && actor.id === associated.id;
};

const getName = (model) => model.full_name || model.name || 'Unknown';
const getActorType = ({ model }) =>
  model !== 'User' ? model.toLowerCase() : '';

const getConversationStartedData = (activity) => {
  return {
    summary: 'Conversation started',
    meta: `via ${activity.channel || 'Unknown'}`,
  };
};

const generateConversationClosedData = (activity) => {
  const { activity_summary, actor } = activity;

  if (!hasCorrectData({ activity })) {
    return {
      summary: activity_summary,
    };
  }

  return {
    summary: `${getName(actor)} closed the conversation`,
  };
};

const generateAssignmentData =
  ({ type, preposition }) =>
  (activity) => {
    const { activity_summary, actor, associated } = activity;

    if (!hasCorrectData({ activity, hasAssociated: true })) {
      return {
        summary: activity_summary,
      };
    }

    const isSelfAssignment = hasAssignedThemselves(activity);

    if (isSelfAssignment) {
      return {
        summary: `${getName(actor)} ${type} ${
          actor.model === 'Bot' ? 'itself' : 'themselves'
        } ${preposition} the conversation`,
      };
    }

    return {
      summary: `${getName(
        associated
      )} was ${type} ${preposition} the conversation`,
      meta: `by ${getName(actor)} ${getActorType(actor)}`,
    };
  };

const getConversationRatedData = (activity) => {
  return {
    summary: activity.activity_summary,
  };
};

const generateConversationReopenedData = (activity) => {
  const { activity_summary, actor } = activity;

  if (!hasCorrectData({ activity })) {
    return {
      summary: activity_summary,
    };
  }

  return {
    summary: `${getName(actor)} reopened the conversation`,
  };
};

export function getActivityDetails(activity) {
  if (!activity) {
    return null;
  }

  const activityStrategies = {
    'conversation-started': getConversationStartedData,
    'conversation-assigned': generateAssignmentData({
      type: 'assigned',
      preposition: 'to',
    }),
    'conversation-unassigned': generateAssignmentData({
      type: 'unassigned',
      preposition: 'from',
    }),
    'conversation-closed': generateConversationClosedData,
    'conversation-rated': getConversationRatedData,
    'conversation-reopened': generateConversationReopenedData,
  };

  const strategy = activityStrategies[activity.activity_type];

  return strategy
    ? { ...strategy(activity), iconClass: iconMap[activity.activity_type] }
    : null;
}
